/*
 * Module for DROP Account - Edit (DROP transaction)
 */
rs.module("content/participant/drop/account/edit",

    [ /* dependencies */],

    function () {

        function initialize(jsSelectors, transactionTypeCodeValues) {

            var transactionForm = $.js(jsSelectors.transactionForm);

            var transactionType = transactionForm.js(jsSelectors.transactionTypeDropdown);
            var processingMonth = transactionForm.js(jsSelectors.processingMonthDropdown, { required: false });
            var processingYear = transactionForm.js(jsSelectors.processingYearTextBox, { required: false });

            // register transaction type changed event
            transactionType.change(transactionTypeChanged);

            if (!processingMonth.prop("disabled")) {
                // if processing month is disabled, page is read only, so don't run/register month changed event
                $(processingMonthChanged);
                processingMonth.change(processingMonthChanged);
            }

            // transaction type change handler
            function transactionTypeChanged() {

                // hide all controls marked as hideable
                transactionForm.js(jsSelectors.hideable, { multiple: true }).hide();

                // only show (hideable) controls corresponding to the selected transaction type
                var selectedTransactionType = transactionType.val();

                if (selectedTransactionType == transactionTypeCodeValues.adjustment) {
                    showControlsForTransactionType(jsSelectors.adjustment);
                }
                else if (selectedTransactionType == transactionTypeCodeValues.benefit) {
                    showControlsForTransactionType(jsSelectors.benefit);
                }
                else if (selectedTransactionType == transactionTypeCodeValues.contribution) {
                    showControlsForTransactionType(jsSelectors.contribution);
                }
                else if (selectedTransactionType == transactionTypeCodeValues.disbursement) {
                    showControlsForTransactionType(jsSelectors.disbursement);
                }
                else if (selectedTransactionType == transactionTypeCodeValues.interest) {
                    showControlsForTransactionType(jsSelectors.interest);
                }
            }

            // takes a selector indicating which transaction type is currently selected, and shows all controls that match that selector
            function showControlsForTransactionType(selector) {
                $(transactionForm).js(selector, { multiple: true }).show();
            }

            // processing month dropdown changed handler - if month is blank, disable and clear year
            function processingMonthChanged() {

                if (!processingMonth.val()) {
                    processingYear.val("").prop("disabled", true);
                }
                else {
                    processingYear.prop("disabled", false);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);